/**
 * 会员权益
 */
import $goods from '@/api/modules/goods'
import { AsyncRequest } from '@/utils/request'
import { checkByDestMobile, imageTokenH5, checkH5VerificationCodeOnly, subVipExamineUpdate, subVipExamineList, subVipExamineInfo } from '@/api/modules/goods/subVip'
import { Toast } from 'vant';
import axios from 'axios'
function countDownFormatFun(start, end) {
  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();
  return endTime - startTime
}

const defaultCommitment = {
  // signUrl: 'https://ylyk-images.ylyk.com/images/web/1665472075479_ADxFx3AxCCRZS4Gf.png?t=' + new Date().getTime(),
  // commitmentUrl: 'https://ylyk-images.ylyk.com/images/web/1665541642827_KkbTESTG8MJBjnPG.png',
  signUrl: '',
  commitmentUrl: '',
  idCardUrl2: '',
  areaCode: '',
  goodsId: null,
  idCardUrl: '',
  receiverIdentity: null, // 家庭卡用户身份 1:子女 2:配偶
  phone: '', captcha: ''
}

const state = {
  userInfo: {},
  goodsArr: [],
  goodsDetail: [],
  termInfo: {}, // 是专清计划的学期
  // 限购规则
  limitData: {
    hasLimit: false,
    limitGoodsIdList: [] // 限购商品
  },
  // 订单弹幕气泡
  orderUserList: [],
  commitmentObj: defaultCommitment // 家庭卡资料
}

const getters = {
  userInfo: state => state.userInfo,
  goodsInfo: state => state.userInfo.goodsInfo,
  goodsDetail: state => state.goodsDetail,
  termInfo: state => state.termInfo,
  // 限购规则
  limitData: state => state.limitData,
  isNeedAuthentic: state => state.isNeedAuthentic,
  // 订单弹幕气泡
  orderUserList: state => state.orderUserList,
  commitmentObj: state => state.commitmentObj
}

const mutations = {
  setUserInfo: (state, info) => {
    state.userInfo = info
  },
  setGoodsDetail: (state, res) => {
    const { goodsInfoList, limitGoodsIdList, termInfo, isNeedAuthentic } = res
    const nowTime = new Date().getTime();
    let isPhysical = false
    // 将渠道信息放到商品里
    goodsInfoList.forEach(item => {
      isPhysical = item.goodsType === '90001' // 实物商品
      item.busiType = res.busiType || ''
      item.channelFirst = res.channelFirst || ''
      item.channelSecond = res.channelSecond || ''
      item.joinActivity = res.joinActivity || ''
      item.nickName = res.nickName || ''
      item.termId = res.termId || ''
      item.userId = res.userId || ''
      item.userName = res.userName || ''
      const s = countDownFormatFun(item.activityStartTime, nowTime)
      if (s < 1000) item.hasActivity = 0; // 优惠活动未开始
      if (item.hasActivity === 1) {
        item.activityStartTime = item.activityStartTime.replace(/-/g, '/')
        item.activityEndTime = item.activityEndTime.replace(/-/g, '/')
        item.countDownFormat = countDownFormatFun(nowTime, item.activityEndTime)
        if (item.countDownFormat < 1000) item.hasActivity = 0; // 优惠活动已结束
      }
    })
    const hasLimit = res.hasLimit === 'true' && !isPhysical
    // 按照价格排序
    // 实物商品不参与排序
    if (hasLimit) {
      const salePriceSort = (x, y) => x.salePrice > y.salePrice ? -1 : 1 // 价格多的在前面
      goodsInfoList.sort(salePriceSort) || []
    }
    state.goodsDetail = goodsInfoList
    // 商品限购只买一个
    const { limitData } = state
    limitData.hasLimit = hasLimit
    limitData.limitGoodsIdList = limitGoodsIdList
    // 业务类型 busiType: "studyplan"
    state.termInfo = termInfo
    state.isNeedAuthentic = isNeedAuthentic || false
  },
  setGoodsBuyInfo: (state, list) => {
    state.orderUserList = list
  },
  // 保存承诺书相关数据
  saveCommitmentDetails(state, obj) {
    state.commitmentObj = Object.assign(state.commitmentObj, obj);
    console.log('更新家庭卡', state.commitmentObj)
  }
}

const actions = {
  getCurrentTime({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => $goods.getCurrentTime(),
      resolve: (_) => {}
    }) 
  },
  checkByDestMobile({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => checkByDestMobile(data),
      resolve: (_) => {}
    }) 
  },
  // 更新申请
  subVipExamineUpdate({ commit }, params) {
    return AsyncRequest({
      loading: true,
      request: () => subVipExamineUpdate(params),
      resolve: (_) => {}
    }) 
  },
  // 获取申请记录详情
  subVipExamineInfo({ commit }, params) {
    return AsyncRequest({
      loading: true,
      request: () => subVipExamineInfo(params),
      resolve: (_) => {}
    })
  },
  // 获取用户家庭卡申请记录
  subVipExamineList({ commit }, params = {}) {
    return AsyncRequest({
      loading: true,
      request: () => subVipExamineList(params),
      resolve: (_) => {}
    })
  },
  // 校验短信验证码
  checkH5VerificationCodeOnly({ commit }, params) {
    return AsyncRequest({
      loading: true,
      request: () => checkH5VerificationCodeOnly(params),
      resolve: (_) => {}
    })
  },
  // 上传至阿里云 家庭卡上传身份证+签名使用
  uploadAliyun({ commit }, { data, src }) {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: '上传中...'
    })
    const path = 'images/web/'
    return new Promise((reslove, reject) => {
      const ossTokenData = data
      const formData = new FormData()
      const key = new Date().getTime() + '_' + random_string(16) + '.png'
      // 注意formData里append添加的键的大小写
      formData.append('name', '')
      formData.append('key', path + key) // 存储在oss的文件路径
      formData.append('OSSAccessKeyId', ossTokenData.accessId) // accessKeyId
      formData.append('policy', ossTokenData.policy) // policy
      formData.append('signature', ossTokenData.signature) // 签名
      // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
      formData.append('file', src)
      formData.append('success_action_status', '200') // 成功后返回的操作码
      // for (const [a, b] of formData.entries()) {
      //   console.log('formdata', a, b)
      // }
      axios({
        method: 'POST',
        url: ossTokenData.host,
        data: formData,
        // async: false,
        cache: false,
        contentType: false, // 必须false才会自动加上正确的Content-Type
        processData: false, // 必须false才会避开jQuery对 formdata 的默认处理
        crossDomain: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(function(res) {
          reslove(`${data.host}/${path}${key}`)
          Toast.clear()
        })
        .catch((err) => {
          console.log('阿里云接口 err', err)
          reject(err)
          Toast.clear()
          Toast({
            message: '我开小差了，重新传一张吧'
          })
        })   
    })
  },
 
  // 用户身份信息
  getPrivilegeLevelByUserId({ commit }) {
    return AsyncRequest({
      loading: true,
      request: () => $goods.getPrivilegeLevelByUserId(),
      resolve: (list) => commit('setUserInfo', list)
    })
  },
  // 商品详情
  getDetailByGoodsId({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $goods.getDetailByGoodsId(payload),
      resolve: (res) => commit('setGoodsDetail', res)
    })
  },
  // 学生认证商品详情
  getDetailByGoodsIdMini({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $goods.getDetailByGoodsIdMini(payload),
      resolve: (res) => commit('setGoodsDetail', res)
    })
  },
  // 用户认证查询
  getAuthenticByUserId({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $goods.getAuthenticByUserId(payload),
      resolve: (res) => {}
    })
  },
  // 用户认证
  authentication({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $goods.authentication(payload),
      resolve: (res) => {}
    })
  },
  // 上传图片至七牛获取token
  imageTokenH5({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => imageTokenH5(payload),
      resolve: (res) => {}
    })
  },
  getGiftCard({ commit }, payload) {
    return AsyncRequest({
      request: () => $goods.getGiftCard(payload)
    })
  },
  // 获取商品的购买用户信息
  getGoodsBuyInfo({ commit, state }, payload) {
    return AsyncRequest({
      request: () => $goods.getGoodsBuyInfo(payload),
      resolve: (res) => commit('setGoodsBuyInfo', res)
    })
  },
  getCommonGoodsBuyInfo({ commit, state }, payload) {
    return AsyncRequest({
      request: () => $goods.getCommonGoodsBuyInfo(payload),
      resolve: (res) => commit('setGoodsBuyInfo', res)
    })
  }
}

function random_string(length) {
  var len = length || 32
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  var maxPos = chars.length
  var pwd = ''
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
